const LOAD_BALANCING = {
  look_back_period_types: {
    days: 'Days',
    months: 'Months',
  },
} as const;

export default LOAD_BALANCING;
